// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Footer = require("./Footer");

var make = Footer.Footer;

exports.make = make;
/* make Not a pure module */
